module.exports = __webpack_public_path__ + "pc/img/release_success.cea8e311.png";